import React, { useContext } from 'react';
import Markdown from '../Markdown';
import styled from 'styled-components/macro';
import Colors from '../../internal-components/Colors';
import { FormContext } from './FormContext';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { hasMarkdown } from '../../utils/hasMarkdown';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const H3 = styled.h3`
  margin: ${({ variant }) =>
    variant === 'tooltip' ? '16px 0 8px !important' : '0.4em 0 0.8em'};
  font-size: 14px;
  color: #000;
  font-weight: 599;

  &:after {
    content: '${({ required }) => (required ? '*' : '')}';
    color: ${Colors.OT_RED};
    font-size: 20px;
  }
`;

const LockIcon = styled(LockOutlinedIcon)`
  align-self: center;
  font-size: 18px !important;
  margin: 0 4px 0 0;
  ${({ $isEditable }) => !$isEditable && 'opacity: 0.5;'}
`;

const unsupportedFieldTypes = {
  instructional_text: true,
  section_break: true,
  confirmation: false
};

const FieldTitle = ({
  title = '',
  isRequired,
  isReadOnly,
  uiType,
  variant
}) => {
  const useMarkdown = hasMarkdown(title);

  const { isReadOnlyFieldsEditable } = useContext(FormContext);

  if (unsupportedFieldTypes[uiType]) {
    return null;
  }

  const titleLines = title.trim().split('\n');

  return (
    <Container role="field-title">
      {isReadOnly && <LockIcon $isEditable={isReadOnlyFieldsEditable} />}
      <H3 required={isRequired} type={uiType} variant={variant}>
        {useMarkdown
          ? titleLines.map((line, i) => (
              <React.Fragment key={i}>
                <Markdown
                  key={i}
                  content={line}
                  allowedTypes={[
                    'root',
                    'text',
                    'link',
                    'emphasis',
                    'listItem',
                    'list'
                  ]}
                />
                {i < titleLines.length - 1 && <br />}
              </React.Fragment>
            ))
          : title}
      </H3>
    </Container>
  );
};

export default FieldTitle;
